import script from "./OrderSuccessPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderSuccessPage.vue?vue&type=script&setup=true&lang=ts"

import "./OrderSuccessPage.vue?vue&type=style&index=0&id=134c9c3e&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134c9c3e"]])

export default __exports__